import Vue from "vue";
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueMeta from "vue-meta";

//绘图包
import * as echarts from "echarts";
import HighchartsVue from "highcharts-vue";

//表格
import VXETable from "vxe-table";
import "vxe-table/lib/style.css";
//表格国际化
import VueI18n from "vue-i18n";
import zhCN from "vxe-table/lib/locale/lang/zh-CN";
import enUS from "vxe-table/lib/locale/lang/en-US";

Vue.prototype.$echarts = echarts; //在原型种绑定echarts

Vue.config.productionTip = false;

Vue.use(Antd);

Vue.use(VXETable);

Vue.use(VueI18n);

Vue.use(HighchartsVue);

Vue.use(VueMeta);

const i18n = new VueI18n({
  locale: "en_US", // 默认语言为英语
  messages: {
    zh_CN: {
      ...zhCN,
    },
    en_US: {
      ...enUS,
    },
  },
});

VXETable.setup({
  // 对组件内置的提示语进行国际化翻译
  i18n: (key, args) => i18n.t(key, args),
});

new Vue({
  router,
  store,
  metaInfo: {
    title:
      "RBPWorld - a comprehensive database fro exploring functions and disease associations of RNA binding proteins across species",
    meta: [
      { name: "keywords", content: "RBP" },
      {
        name: "description",
        content:
          "A comprehensive database fro exploring functions and disease associations of RNA binding proteins across species",
      },
    ],
  },
  render: (h) => h(App),
}).$mount("#app");
